import {
  isSameOriginMountPath,
  SAME_ORIGIN_GAME_CLIENT_PATH,
} from './same-origin-path';

import { isEmbeddedInLobby } from '@/logic/embedded-mode';
import { isViteDevServer } from './isViteDevServer';

export const buildClientURL = () => {
  // Same-origin game-window v3 lobby mount (`/game-window-play`): game-client
  // is a directory route, so keep the trailing slash before any query string.
  if (isSameOriginMountPath(globalThis.location.pathname)) {
    const { protocol, host } = globalThis.location;
    const embeddedQuery = isEmbeddedInLobby() ? '?embedded=1' : '';
    return `${protocol}//${host}${SAME_ORIGIN_GAME_CLIENT_PATH}/${embeddedQuery}`;
  }
  let clientURL: string = window.location.hostname.replace('gw.', 'gc.');

  if (isViteDevServer()) {
    clientURL = clientURL + ':5173';
  }

  const finalURL = 'https://' + clientURL;

  return finalURL;
};
